import { render, staticRenderFns } from "./Heyuan.vue?vue&type=template&id=321ff527&scoped=true&"
import script from "./Heyuan.vue?vue&type=script&lang=js&"
export * from "./Heyuan.vue?vue&type=script&lang=js&"
import style0 from "./Heyuan.vue?vue&type=style&index=0&id=321ff527&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321ff527",
  null
  
)

export default component.exports